import React from 'react'
import { useTranslation } from 'react-i18next'

const WelcomeSlide: React.FC = () => {
	const { t } = useTranslation('pages_onboarding')

	return (
		<>
			<h1 className='text-text-dark dark:text-white'>{t('welcomeSlide.hei')}</h1>
			<p className='text-text-grey-200 dark:text-text-grey-100 text-center'>
				{t('welcomeSlide.tervetuloa')}
			</p>
			<p className='text-text-grey-200 dark:text-text-grey-100 text-center'>
				{t('welcomeSlide.vastaaKysymyksiin')}
			</p>
			<p className='text-text-grey-200 dark:text-text-grey-100 text-center'>
				{t('welcomeSlide.siinaMeneeHetki')}
			</p>
		</>
	)
}
export default WelcomeSlide
